// extracted by mini-css-extract-plugin
export default {"discountNote":"ConfirmProductUpdateModal_discountNote__JEfjU","infoIcon":"ConfirmProductUpdateModal_infoIcon__j8fQJ"};